import React, { useEffect, useState } from 'react';

export default function RelojChile() {
  const [fechaHora, setFechaHora] = useState({ fecha: '', hora: '' });

  useEffect(() => {
    const actualizar = () => {
      const ahora = new Date();
      const opcionesFecha = {
        timeZone: 'America/Santiago',
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      const opcionesHora = {
        timeZone: 'America/Santiago',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };
      setFechaHora({
        fecha: new Intl.DateTimeFormat('es-CL', opcionesFecha).format(ahora),
        hora: new Intl.DateTimeFormat('es-CL', opcionesHora).format(ahora)
      });
    };

    actualizar();
    const id = setInterval(actualizar, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 bg-white shadow-lg rounded-xl px-4 py-3 text-sm text-gray-800 z-40 border border-gray-200 w-72">
      <div className="font-medium truncate">{fechaHora.fecha}</div>
      <div className="font-semibold text-lg mt-1">{fechaHora.hora}</div>
    </div>
  );
}
